import React from 'react';

const AffiliationsSection = () => (
  <section className="affil" aria-label="Affiliations" data-testid="affiliations-section">
    <h4>Affiliations</h4>
    <a href="https://www.thepims.co.uk/" title="PIMS, Property Investors Mediation Service">
      <img
        src="https://res.cloudinary.com/dp6nne059/image/upload/v1773333819/Pims_Logo_Blue_pyaxwu.jpg"
        alt="PIMS, Property Investors Mediation Service"
      />
    </a>
    <small>PIMS member No. 133801</small>
  </section>
);

export default AffiliationsSection;
